import styled from 'styled-components';

import Link from 'components/link';

export const PrepaidTransferBalanceLink = styled(Link)`
  width: 100%;
  padding: 0.8rem;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  text-transform: capitalize;
  color: ${({ theme }) => theme.token('text-link-default')};

  &:hover {
    color: ${({ theme }) => theme.token('text-link-hover')};
  }
`;
